interface CrabLogoProps {
  size?: number;
  color?: string;
}

// Minimal top-down crab glyph for the "CrABs" (Crypto Alt Bots) brand mark —
// body, two claws, two eye stalks, legs. Deliberately geometric/abstract
// (no face, no hat, no tie) so it reads as "a crab" without leaning on any
// specific cartoon character's design.
export function CrabLogo({ size = 16, color = "currentColor" }: CrabLogoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 15 L2 18 M6 16.5 L2.5 20.5 M18 15 L22 18 M18 16.5 L21.5 20.5"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path d="M6 9 C3 8 1.5 5.5 2.5 3.5 C4.5 4 6 6 6.5 8.5 Z" fill={color} />
      <path d="M18 9 C21 8 22.5 5.5 21.5 3.5 C19.5 4 18 6 17.5 8.5 Z" fill={color} />
      <path d="M9.5 7 L8.5 4" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M14.5 7 L15.5 4" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="8.3" cy="3.2" r="1.1" fill={color} />
      <circle cx="15.7" cy="3.2" r="1.1" fill={color} />
      <ellipse cx="12" cy="13" rx="6.5" ry="4.6" fill={color} />
    </svg>
  );
}
